import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import {
  ScrapChefUsageDetailedPoint,
  useGetStrategyDashboardScrapChefUsageDetailedQuery,
} from "src/store/api/generatedApi";

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);

export interface ScrapChefUsageDetailedTabData {
  weekly: ScrapChefUsageDetailedPoint[];
}

export const useStrategyDashboardScrapChefUsageDetailed =
  (): Loaded<ScrapChefUsageDetailedTabData> => {
    const loadedRawData = loadedEndpoint(
      useGetStrategyDashboardScrapChefUsageDetailedQuery({
        tenantName: useTenant(),
      })
    );
    if (loadedRawData.status === "success") {
      return {
        status: "success",
        data: { weekly: excludeIncompleteWeeks(loadedRawData.data.weekly) },
        fetching: loadedRawData.fetching,
      };
    }
    return loadedRawData;
  };

const excludeIncompleteWeeks = (
  weekly: ScrapChefUsageDetailedPoint[]
): ScrapChefUsageDetailedPoint[] => {
  const now = dayjs.utc();
  return weekly.filter((d) =>
    dayjs.utc(d.period_start).add(1, "week").isSameOrBefore(now)
  );
};
